import { DownloadFileAPI } from '../../../api/bussched/DownloadFileAPI';

export class DownloadCommand {
    constructor() {
        this.downloadFileApi = new DownloadFileAPI();
    }

    downloadLayout(layout, successCallback, errorCallback) {
        const apiResult = this.downloadFileApi.downloadLayout(layout.id);
        apiResult.then(async (result) => {
            if (undefined !== successCallback) {
                successCallback(await result.blob(), `${layout.name}.ipublayout`);
            }
        }).catch((ex) => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a transferir o ficheiro.");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/commands/DownloadCommand.js